import _objectSpread from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        admin_id: "",
        name: "",
        avatar: "",
        age: "",
        phone: '',
        sex: "",
        level: "",
        introduction: ''
      },
      imgList: [],
      isModify: false,
      rules: {
        name: [{
          required: true,
          message: "请输入姓名",
          trigger: "blur"
        }],
        age: [{
          required: true,
          message: "请输入年龄",
          trigger: "blur"
        }],
        phone: [{
          required: true,
          message: "请输入电话",
          trigger: "blur"
        }],
        sex: [{
          required: true,
          message: "请选择性别",
          trigger: "blur"
        }],
        level: [{
          required: true,
          message: "请输入等级",
          trigger: "blur"
        }],
        introduction: [{
          required: true,
          message: "请输入简介",
          trigger: "blur"
        }],
        avatar: [{
          required: true,
          message: "请上传头像",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(data, type) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var datas;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (type) {
                  _this.isModify = true;

                  _this.copyPrimitive();

                  datas = JSON.parse(JSON.stringify(data));
                  _this.formData = _objectSpread({}, datas);
                  _this.imgList = [datas.avatar];

                  _this.copyData();
                } else {
                  _this.isModify = false;
                  _this.formData.admin_id = data;
                }

                _this.dialogFormVisible = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    imgChange: function imgChange(e) {
      console.log("e====", e);
      this.imgList = e;
      this.formData.avatar = e[0] && e[0].response ? e[0].response.url : '';
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.imgList = isClear ? [] : this.formDataMake.avatar ? [this.formDataMake.avatar] : [];
      this.clearData(isClear);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    var reqFn = _this2.isModify ? 'updateCoaches' : 'addCoaches';

                    _this2.$api[reqFn](_this2.formData).then(function (res) {
                      if (res.code == 200) {
                        _this2.$message.success('添加成功');

                        _this2.$emit('change');

                        _this2.dialogFormVisible = false;
                      } else {
                        _this2.$message.error(res.msg);
                      }
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};